import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import barlowFont from "./../Barlow/Barlow-SemiBold.ttf";
import barlowFontRegular from "./../Barlow/Barlow-Regular.ttf";
import logo_constancia from "./../../../assets/iconos/logo_constancia.png";


Font.register({ family: "Barlow", src: barlowFont });

Font.register({ family: "BarlowRegular", src: barlowFontRegular });

const FechaDescarga = () => {
  const date = new Date();
  const options = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    hour12: true, // esta opción muestra la hora en formato de 12 horas
    timeZone: "America/Lima",
  };

  const formattedDate = date.toLocaleString("es-PE", options);

  return formattedDate;
};

const FechaFooter = (fecha) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  const date = new Date(fecha);
  const day = date.getDate().toString().padStart(2, "0");
  const month = new Intl.DateTimeFormat("es-PE", options)
    .format(date)
    .split(" ")[2];
  const year = date.getFullYear();
  return `${day} de ${month} de ${year}`;
};

const groupById = (datatosConstacias) => {
  let grupos = Object.values(
    datatosConstacias.reduce((result, item) => {
      const key = item.ccurso + item.scurso;
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(item);
      return result;
    }, {})
  );

  return grupos;
};

const HorarioPdf = ({ datatosConstacia }) => {
  const styles = StyleSheet.create({
    page: {
      padding: 40,
      height: "100%",
      position: "relative",
    },
    imageContainer: {
      height: "100px",
      width: "100%",

      display: "flex",
      flexDirection: "row",

      justifyContent: "center",
    },
    image: {
      width: "270px",
      height: "90px",
    },

    header2: {
      flexDirection: "row",
      borderBottomColor: "#e6e6e6",
      borderBottomWidth: 1,
      alignItems: "center",
      height: 20,
      textAlign: "center",
      fontStyle: "bold",
      fontSize: 8,
      color: "white",
      fontWeight: "bold",
      backgroundColor: "#e6e6e6",
      marginTop: 5,
      paddingLeft: 5,
      paddingRight: 5,
    },
    table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#e6e6e6",
      // marginTop: 5,
      marginBottom: 5,
    },
    tableRow: {
      margin: "auto",
      flexDirection: "row",
      backgroundColor: "#fff",
    },
    tableCol: {
      width: "40%",
      borderStyle: "solid",
      borderWidth: 0.5,
      borderColor: "#e6e6e6",
      margin: 0,
      textAlign: "center",
      padding: 5,
    },
    colHeader: {
      backgroundColor: "#e6e6e6",
      color: "#333",
      fontWeight: "bold",
      fontSize: 8,
      width: "40%",
    },
    colData: {
      fontSize: 8,
    },

    fontFamilys: {
      fontFamily: "BarlowRegular",
    },
    title: {
      textAlign: "center",
      fontWeight: "700",
      textTransform: "uppercase",
      fontFamily: "Barlow",
      fontSize: "15px",
    },
    titleRight: {
      textAlign: "right",
      marginTop: "10px",
      marginBottom: "10px",
      fontSize: "12px",
      fontFamily: "Barlow",
    },
    textUppercase: {
      textTransform: "uppercase",
    },
    textResumen: {
      fontSize: "10px",
      fontFamily: "Barlow",
    },
    negrita: {
      fontFamily: "Barlow",
    },
    textFooter: {
      fontSize: "10px",
      fontFamily: "Barlow",
    },
    textNormal: {
      fontFamily: "BarlowRegular",
    },
    paddingResunen: {
      padding: "15px 0 15px 0",
    },
    tarjetaResumen: {
      width: "120px",
      padding: "8px",
      border: "1.5px solid #adadad",
      borderRadius: "5px",
      marginRight: "10px",
      fontSize: "11px",
    },
    contentTarjeta: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",

      width: "100%",
    },
    footer: {
      width: "100%",
      textAlign: "center",
      position: "absolute",
      left: "10%",
      bottom: 25,
      fontFamily: "BarlowRegular",
      fontSize: "12px",
    },
    header: {
      width: "100%",
      textAlign: "center",
      position: "absolute",
      left: "10%",
      top: 25,
      fontFamily: "BarlowRegular",
      fontSize: "12px",
    },
    imgFirma: {
      width: "120px",
      height: "65px",
    },
  });



  const watermarkStyle = {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 50,
    position: "absolute",
    top: 0,
    width: "100%",

  };

  const textWatermarkStyle = {
    color: "rgba(0, 0, 0, 0.2)",
    fontSize: 80,
    fontFamily: "Barlow",
    fontWeight: 700,
    textTransform: "uppercase",
    transform: "rotate(-45deg)",
    userSelect: "none",
    textAlign: "center",
  };


  return (
    <Document size="A4" key={"1a"}>
      {Object.entries(datatosConstacia)?.map(([index, item]) => {
        return (
          <Page style={styles?.page} key={index} wrap>
            <View fixed style={styles.header}>
              <Text style={{ textAlign: "left", fontSize: "10px" }}>
                {FechaDescarga()}
              </Text>
            </View>
            <View style={styles?.imageContainer}>
              <Image style={styles?.image} src={logo_constancia} />
            </View>
            {index == 0 && (
              <>
                <View>
                  <Text style={styles.title}>
                    MATRÍCULA SEMESTRE {item[0][0].speriodo}
                  </Text>
                </View>
                <View
                  style={{
                    ...styles.textResumen,
                    marginTop: "15px",
                    marginBottom: "15px",
                  }}
                >
                  <Text style={styles.textResumen}>
                    ESTUDIANTE:
                    <Text
                      style={{ ...styles.textNormal, textAlign: "justify" }}
                    >
                      {" "}
                      {`${item[0][0]?.ndoc_identidad} - ${item[0][0]?.destudiante}`}
                    </Text>
                  </Text>
                  <Text style={styles.textResumen}>
                    CARRERA:
                    <Text
                      style={{ ...styles.textNormal, textAlign: "justify" }}
                    >
                      {" "}
                      {item[0][0]?.dcarrera}
                    </Text>
                  </Text>

                  <View>
                    <Text
                      style={{
                        marginTop: "25px",
                        marginBottom: "2px",
                        textAlign: "center",
                        borderBottomStyle: "solid",
                        borderBottomColor: "#2b2b2b",
                        borderBottomWidth: 0.5,
                        padding: "5px",
                      }}
                    >
                      ASIGNATURAS MATRICULADAS
                    </Text>
                  </View>
                </View>
              </>
            )}
            {Object.entries(item).map(([index1, d]) => {
              let newIndex = index1 ? 0 : 1;
              return (
                <View key={index1}>
                  <View
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: index1 === 0 ? "" : "20px",
                    }}
                  >
                    <View style={{ flex: 1, flexDirection: "column" }}>
                      <Text
                        style={{
                          ...styles.negrita,
                          paddingBottom: "5px",
                          lineHeight: "1.5",
                          width: "100%",
                          fontSize: "9px",
                        }}
                      >
                        SEDE:{" "}
                        <Text style={{ ...styles.textNormal, fontSize: "8px" }}>
                          {d[newIndex]?.dsede}
                        </Text>
                      </Text>
                      <Text
                        style={{
                          ...styles.negrita,
                          paddingBottom: "5px",
                          lineHeight: "1.5",
                          width: "100%",
                          fontSize: "9px",
                        }}
                      >
                        DIRECCIÓN:{" "}
                        <Text style={{ ...styles.textNormal, fontSize: "8px" }}>
                          {d[newIndex]?.ddireccion}
                        </Text>
                      </Text>
                      <Text
                        style={{
                          ...styles.negrita,
                          paddingBottom: "5px",
                          lineHeight: "1.5",
                          width: "100%",
                          fontSize: "9px",
                        }}
                      >
                        COORDINADOR:{" "}
                        <Text style={{ ...styles.textNormal, fontSize: "8px" }}>
                          {d[newIndex]?.dcoordinador}
                        </Text>
                      </Text>
                      <Text
                        style={{
                          ...styles.negrita,
                          paddingBottom: "5px",
                          lineHeight: "1.5",
                          width: "100%",
                          fontSize: "9px",
                        }}
                      >
                        CURSO:{" "}
                        <Text style={{ ...styles.textNormal, fontSize: "8px" }}>
                          {d[newIndex]?.dcurso}
                        </Text>
                      </Text>
                    </View>

                    <View
                      style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        textAlign: "right",
                      }}
                    >
                      <Text
                        style={{
                          ...styles.negrita,
                          paddingBottom: "5px",
                          lineHeight: "1.5",
                          width: "100%",
                          fontSize: "9px",
                        }}
                      >
                        CRÉDITOS:{" "}
                        <Text style={{ ...styles.textNormal, fontSize: "8px" }}>
                          {d[newIndex]?.ncredito}
                        </Text>
                      </Text>
                      <Text
                        style={{
                          ...styles.negrita,
                          paddingBottom: "5px",
                          lineHeight: "1.5",
                          width: "100%",
                          fontSize: "9px",
                        }}
                      >
                        GRUPO:{" "}
                        <Text style={{ ...styles.textNormal, fontSize: "8px" }}>
                          {d[newIndex]?.sgrupo}
                        </Text>
                      </Text>
                    </View>
                  </View>

                  <View>
                    <View style={{ ...styles.header2 }}>
                      <Text style={{ ...styles.colHeader, width: "10%" }}>
                        Inicio
                      </Text>
                      <Text style={{ ...styles.colHeader, width: "10%" }}>
                        Fin
                      </Text>
                      <Text style={styles.colHeader}>Horario</Text>
                      <Text style={styles.colHeader}>Aula</Text>
                    </View>
                    <View style={styles.table}>
                      {d.map((row, i) => (
                        <View style={styles.tableRow} key={i}>
                          <Text
                            style={{
                              ...styles.tableCol,
                              ...styles.colData,
                              width: "10% !important",
                            }}
                          >
                            {row.finicio}
                          </Text>
                          <Text
                            style={{
                              ...styles.tableCol,
                              ...styles.colData,
                              width: "10% !important",
                            }}
                          >
                            {row.ffin}
                          </Text>
                          <Text
                            style={{ ...styles.tableCol, ...styles.colData }}
                          >
                            {row.dhorario}
                          </Text>
                          <Text
                            style={{ ...styles.tableCol, ...styles.colData }}
                          >
                            {row.daula}
                          </Text>
                        </View>
                      ))}
                    </View>
                  </View>
                </View>
              )
            })}

            <View style={styles.footer} fixed>
              <Text style={{ width: "100%", fontSize: "10px" }}>
                Av. Honorio Delgado 430, Urbanización Ingeniería, San Martín de
                Porres
              </Text>
              <Text style={{ width: "100%", ...styles.textFooter }}>
                www.upch.edu.pe
              </Text>

              <Text
                style={{ textAlign: "right", fontSize: "10px" }}
                render={({ pageNumber, totalPages }) =>
                  `${pageNumber} / ${totalPages}`
                }
                fixed
              />
            </View>
          </Page>
        );
      })}
    </Document>
  );
};

export default HorarioPdf;
